import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {CreateRepairService} from "./services/create-repair.service";
import {PartGroupDto} from "../../../auto-generated-server-dtos/claim/repairs/part-group-dto";
import {GetRepairsAtTimeOfSubmissionService} from "./services/get-repairs-at-time-of-submission.service";
import {GetRepairsService as GetAdjusterRepairsService} from "../../../adjuster/components/claim/repairs/services/get-repairs.service";
import {GetRepairsService} from "./services/get-repairs.service";
import {Subject} from "rxjs";
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import { PartDto } from 'src/app/auto-generated-server-dtos/claim/repairs/part-dto';
import { GetAllPartsService } from 'src/app/adjuster/components/claim/repairs/services/get-all-parts.service';
import {GetAvailablePartsService} from './services/get-available-parts.service';

@Component({
  selector: 'app-repairs',
  templateUrl: './repairs.component.html',
  styleUrls: ['./repairs.component.css']
})
export class RepairsComponent implements OnInit {

  @Input() ClaimDto: ClaimDto | null = null;
  @Input() IsAdjusterView = false;
  @Output() totalUpdated = new EventEmitter<number>();
  @Output() repairsUpdated = new EventEmitter<RepairDto[]>();
  public Repairs: RepairDto[] = [];
  @Input() public Submitted?: Subject<void>;
  public availablePartGroups: PartGroupDto[] = [];
  public total = 0;
  public addingRepair = false;
  public repairsAtTimeOfSubmission: { [key: number]: RepairDto } | null = null;
  public loadingRepairs = false;

  constructor(private addRepairService: CreateRepairService, private getAvailablePartsService: GetAvailablePartsService, private getAllPartsService: GetAllPartsService, private getRepairsAtTimeOfSubmissionService: GetRepairsAtTimeOfSubmissionService, private getRepairsService: GetRepairsService, private getAdjusterRepairsService: GetAdjusterRepairsService) {
  }

  ngOnInit(): void {
    this.calculateTotal();

    this.getAvailableParts();
    this.refreshRepairs();
    this.getRepairsAtTimeOfSubmission();
    this.Submitted?.subscribe(() => {
      this.refreshRepairs();
    });
  }

  private refreshRepairs() {
    this.IsAdjusterView ? this.getAdjusterRepairs() : this.getRepairs();
  }

  private getAdjusterRepairs() {
    this.loadingRepairs = true;
    this.getAdjusterRepairsService.GetRepairs(this.ClaimDto!.claimId).subscribe({
      next: (repairs) => {
        this.Repairs = repairs;
        this.calculateTotal();
        this.repairsUpdated.emit(this.Repairs);
      },
      error: () => {
        this.loadingRepairs = false;
      },
      complete: () => {
        this.loadingRepairs = false;
      }
    });
  }

  private getRepairs() {
    this.loadingRepairs = true;
    this.getRepairsService.GetRepairs(this.ClaimDto!.claimId).subscribe({
      next: (repairs) => {
        this.Repairs = repairs;
        this.calculateTotal();
        this.repairsUpdated.emit(this.Repairs);
      },
      error: () => {
        this.loadingRepairs = false;
      },
      complete: () => {
        this.loadingRepairs = false;
      }
    });
  }

  private getRepairsAtTimeOfSubmission() {
    if (!this.ClaimDto!.isSubmitted) return;
    this.getRepairsAtTimeOfSubmissionService.GetRepairsAtTimeOfSubmission(this.ClaimDto!.claimId).subscribe((repairs) => {
      this.repairsAtTimeOfSubmission = repairs.reduce((map, repair) => {
        map[repair.repairId] = {...repair};
        return map;
      }, {} as { [key: number]: RepairDto });
    });
  }

  private getAvailableParts() {
    if (!this.IsAdjusterView) {
      this.getAvailablePartsService.GetAvailableParts(this.ClaimDto!.warrantyId).subscribe((partGroups) => {
        this.availablePartGroups = partGroups;
      });
    } else {
      this.getAllPartsService.GetAllParts().subscribe((partGroups) => {
        this.availablePartGroups = partGroups
      })
    }
    
  }

  setUpdatedRepairs(part: PartDto) {
    let updatedList = this.Repairs.map(repairItem => {
      if (repairItem.partId == part.partId) {
        return {
          ...repairItem,
          partLabel: part.label
        }
      }
      return repairItem
    })

    this.Repairs = updatedList;
    this.repairsUpdated.emit(this.Repairs); // passes up to = claim component
  }
  calculateTotal() {
    this.total = 0;
    this.Repairs.forEach((repair) => {
      this.total += repair.total || 0;
    });
    this.totalUpdated.emit(this.total);
  }

  removeRepairFromInMemoryArray(repair: RepairDto) {
    this.Repairs = this.Repairs.filter((r) => r.repairId !== repair.repairId);
    this.calculateTotal();
    this.refreshRepairs();
  }

  addRepair() {
    this.addingRepair = true;
    this.addRepairService.CreateRepair(this.ClaimDto!.claimId).subscribe((repair) => {
      this.Repairs.push(repair);
      this.addingRepair = false;
    });
  }

}
